import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";
import { useAuth } from "../contexts/AuthContext";
import googleIcon from "../assets//icons/google-icon.jpg";
import Head from '../components/Head';

function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State for eye icon
  const [status, setStatus] = useState({ message: "", type: "" });

  const { loginWithEmail, signUpWithGoogle } = useAuth(); // Get new functions
  const navigate = useNavigate();

  // --- Handler for Email/Password Form ---
  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus({ message: "Logging in...", type: "loading" });

    try {
      await loginWithEmail(email, password);
      // The onAuthStateChanged listener in AuthContext
      // will set the user and App.js will redirect to '/'
      navigate("/"); // Force redirect
    } catch (error) {
      setStatus({ message: "Invalid email or password", type: "error" });
    }
  };

  // --- Handler for Google Sign-In Button ---
  const handleGoogleSignIn = async () => {
    try {
      await signUpWithGoogle();
      // The onAuthStateChanged listener will handle the redirect
    } catch (error) {
      setStatus({ message: error.message, type: "error" });
    }
  };

  return (

     <>
                {/* --- ADDED: SEO METADATA --- */}
                <Head 
                    title="Sign In to PDF Play – Access Your All-in-One PDF Tools"
                    description="Log in to your PDF Play account and continue managing, converting, and editing your PDFs with ease. Secure, fast, and free access to all tools."
                />
                {/* --- END SEO METADATA --- */}




    <div className="auth-page-container">
      <div className="auth-wrapper">
        <h2>Sign in to PDF Play</h2>
        <form className="auth-form" onSubmit={handleLogin}>
          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.message}
            </div>
          )}

          <div className="auth-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="auth-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="auth-form-group">
            <label htmlFor="password">Password</label>
            {/* --- NEW: Password Wrapper --- */}
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                className="auth-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span
                className="password-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i
                  className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                ></i>
              </span>
            </div>
            {/* --- END: Password Wrapper --- */}
            <div className="auth-link">
              <Link to="#">Forgot password?</Link>
            </div>
          </div>

          <button type="submit" className="auth-button">
            Sign in
          </button>
        </form>

        <div className="auth-separator">
          <br></br>
          <br></br>
          <span>Or sign in with</span>
        </div>

        <div className="social-login-buttons">
          <button onClick={handleGoogleSignIn} className="google-auth-button">
            <img src={googleIcon} alt="Google" className="google-icon" />
            <span>Login with Google</span>
          </button>
        </div>

        <div className="auth-switch-link">
          Don't have an account? <Link to="/signup">Sign up</Link>
        </div>
      </div>
    </div>
    </>
  );
}

export default LoginPage;
